import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';
import eventInfo from '../../../../../lib/components/eventInfo';
import primaryClaimEditor from '../primaryClaimEditor';
import secondaryClaimEditor from '../secondaryClaimEditor';
import confirmModal from '../../../../../lib/components/modals/confirmModal';
import errorList from '../../../../../lib/components/errorList';
import { DEBUG } from '../../../../../lib/constants';
import translationModuleName from '../../../../../lib/translation';

// Controller
import ClaimsModalController from './claimsModal.controller';
import template from './claimsModal.html';
import './claimsModal.css';

const moduleName = 'staff.dashboardScreen.claimsModal';
let module = angular.module(moduleName, [
  uiModal,
  'recaps.services',
  'constants',
  eventInfo.name,
  primaryClaimEditor.name,
  secondaryClaimEditor.name,
  confirmModal.name,
  errorList.name,
  translationModuleName,
]);

module.controller('ClaimsModalController', ClaimsModalController);

module.factory('showClaimsModal', ['$uibModal', '$q', ($uibModal, $q) => {
  const showClaimsModal = props => {
    console.debug(`showClaimsModal() called with props:`, props);
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: ClaimsModalController,
      controllerAs: 'vm',
      size: 'lg',
      backdrop: props.usePromptRecapCheckoutClaim ? 'static' : true,
      keyboard: props.usePromptRecapCheckoutClaim ? false : true, 
      resolve: {
        $q: () => $q,
        DEBUG: () => DEBUG,
        position: () => props.position,
        staffUser: () => props.staffUser,
        primaryClaim: () => props.primaryClaim,
        secondaryClaims: () => props.secondaryClaims,
        event: () => props.event,
        editingMode: () => props.editingMode,
        modalClass: () => props.modalClass,
      }
    });
    return modal.result;
  };
  return showClaimsModal;
}]);

export default module;
